import LoadingActions from '../actions/LoadingActions';

export function createLoadingDecoratorFor(type) {
    return function withLoadingActions(target, name, descriptor) {
        let original = descriptor.value;
        descriptor.value = LoadingActions.wrap(type)(original);
        descriptor.value.__DECORATORS = ['withLoadingActions'].concat(original.__DECORATORS || []); // for unit tests
        return descriptor;
    };
}



// WEBPACK FOOTER //
// ./src/decorators/Loading.js